import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Checkbox,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import PhotoContainer from '../PhotoContainer';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import {
  getRoleNames,
  getWorkTypeNameById,
  getOwnershipOptionByWorkType,
  floatFormat,
} from '../../utils';
import Select from '../Select';

class TeamMembersEdit extends Component {
  constructor() {
    super();
    this.state = {
      current: null,
      showAll: true,
      members: [],
    };
  }

  componentWillMount() {
    const { team } = this.props;
    if (team) {
      this.props.loadMembers(team.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    let { members } = nextProps;
    const { status } = nextProps;

    if (
      status === actionTypes.MEMBERS_GET_SUCCESS &&
      status !== this.props.status
    ) {
      if (members && members.length && this.state.current === null) {
        let current = members[0];

        for (let i = 0; i < members.length; i++) {
          if (members[i].ownership && !members[i].ownership.ownership_type) {
            const index = R.findIndex(R.propEq('id', members[i].id))(members);
            const ownership = {
              ...members[index].ownership,
              ownership_type: 0,
            };

            members[index].ownership = ownership;
            if (i === 0) {
              current.ownership = ownership;
            }
          }
        }
        this.setState({ current });
      }

      this.setState({ members });
      this.props.onUpdateMembers(members);
    }

    if (
      nextProps.nextCollaborator !== this.props.nextCollaborator &&
      nextProps.nextCollaborator
    ) {
      this.setState({ current: nextProps.nextCollaborator });
    }
  }

  changeCurrent(member) {
    this.setState({ current: member });
    this.props.setCurrentMember(member);
  }

  handleOwnership(e) {
    let { current, members } = this.state;

    const index = R.findIndex(R.propEq('id', current.id))(members);
    const ownership = {
      ...members[index].ownership,
      percentage: e.target.value,
    };

    members[index].ownership = ownership;
    current.ownership = ownership;
    this.setState({ current, members: members.concat() });
    this.props.onUpdateMembers(members);
  }

  handleOwnershipType(value) {
    let { current, members } = this.state;

    const index = R.findIndex(R.propEq('id', current.id))(members);
    const ownership = {
      ...members[index].ownership,
      ownership_type: parseInt(value, 10),
    };

    members[index].ownership = ownership;
    current.ownership = ownership;
    this.setState({ current, members: members.concat() });
    this.props.onUpdateMembers(members);
  }

  handleMemberDefault(e) {
    let { current, members } = this.state;

    const index = R.findIndex(R.propEq('id', current.id))(members);
    members[index].default = e.target.checked;
    current.default = e.target.checked;

    this.setState({ current, members: members.concat() });
    this.props.onUpdateMembers(members);
  }

  addPublisher = () => {
    const { current } = this.state;

    if (current) {
      if (!current.publishers) {
        current.publishers = [];
      }

      current.publishers.push({
        publisherName: '',
        society: '',
        publisher_share: '',
      });

      this.setState({ current: { ...current } });
    }
  };

  handlePublisher = (e, key, i) => {
    const { current, members } = this.state;

    if (current.publishers[i]) {
      current.publishers[i][key] = e.target.value;

      if (key === 'publisher_share') {
        current.publishers[i][key] = e.target.value || 0;
      }

      const index = R.findIndex(R.propEq('id', current.id))(members);
      members[index].publishers = current.publishers;

      this.setState({ current: { ...current }, members: [...members] });
      this.props.onUpdateMembers(members);
    }
  };

  removePublisher = (i) => {
    const { current, members } = this.state;

    if (current.publishers[i]) {
      current.publishers.splice(i, 1);

      const index = R.findIndex(R.propEq('id', current.id))(members);
      members[index].publishers = current.publishers;

      this.setState({ current: { ...current }, members: [...members] });
      this.props.onUpdateMembers(members);
    }
  };

  renderMembers() {
    const members = this.state.showAll
      ? this.state.members
      : this.state.members.slice(0, 3);

    if (members && members.length) {
      return members.map((member, i) => {
        let selected = false;

        if (
          this.state.current &&
          member.user_info.id === this.state.current.user_info.id
        )
          selected = true;

        const percentage =
          member.ownership && member.ownership.percentage
            ? floatFormat(member.ownership.percentage)
            : 0;

        return (
          <Row
            key={i}
            className="team-member cursor-hand"
            onClick={() => this.changeCurrent(member)}
          >
            <Col sm={12}>
              <hr className="border" />
            </Col>
            <Col md={3}>
              <PhotoContainer
                className={`photo-container ${selected ? 'selected' : ''}`}
                image={member.user_info.avatar}
                defaultImg="user"
              />
            </Col>
            <Col md={5}>
              <span>{member.user_info.name}</span>
            </Col>
            <Col md={4}>
              <span className="text-gray">{percentage}%</span>
            </Col>
          </Row>
        );
      });
    } else {
      return <p>No members</p>;
    }
  }

  renderShowToggle() {
    if (this.state.members.length > 3) {
      return (
        <div className="text-right">
          <hr className="border" />
          {this.state.showAll ? (
            <a
              className="list-all"
              onClick={() => this.setState({ showAll: false })}
            >
              Show less
            </a>
          ) : (
            <a
              className="list-all"
              onClick={() => this.setState({ showAll: true })}
            >
              List all
            </a>
          )}
        </div>
      );
    }
  }

  renderTotal() {
    const { members } = this.state;
    let sum = 0;

    if (members && members.length) {
      members.forEach((m) => {
        let percentage =
          m.ownership && m.ownership.percentage
            ? parseFloat(m.ownership.percentage, 10)
            : 0;
        sum += percentage;
      });
      sum = parseFloat(floatFormat(sum), 10);

      let className =
        sum < 100 ? 'text-gray' : sum > 100 ? 'text-red' : 'text-green';

      return (
        <Row>
          <Col md={4}>
            <span className="text-gray">Team Total</span>
          </Col>
          <Col md={4}>
            <span className={className}>{sum}%</span>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  }

  renderCurrentMember() {
    const { roles } = this.props;
    const { current } = this.state;

    if (current === null) {
      return <div>Loading...</div>;
    } else {
      const roleNames = getRoleNames(current.role_ids, roles);

      return (
        <div className="member-info">
          <PhotoContainer
            className="photo-container"
            image={current.user_info.avatar}
            defaultImg="user"
          />
          <div className="current-info">
            {current.user_info.company_name &&
            current.user_info.use_company_name ? (
              <div className="user-name">{current.user_info.company_name}</div>
            ) : null}
            <div className="user-name">{current.user_info.name}</div>
            <div className="user-email">{current.user_info.email}</div>
            <div className="user-roles">{roleNames.join(', ')}</div>
          </div>
          <div className="edit-link">
            {/* <Link to={`/teams/${team.id}/detail`}>edit</Link> */}
          </div>
        </div>
      );
    }
  }

  renderOwnership() {
    const { fields, workTypes, ownershipTypes, soundRecordingType } =
      this.props;
    const { current } = this.state;

    const percentage =
      current.ownership && current.ownership.percentage
        ? current.ownership.percentage
        : 0;
    let ownershipType =
      current.ownership && current.ownership.ownership_type
        ? current.ownership.ownership_type
        : 0;
    if (!ownershipType) {
      ownershipType = 0;
    }

    let publishable = false;
    if (fields.type) {
      const workTypeName = getWorkTypeNameById(fields.type, workTypes);
      publishable = workTypeName === 'Music';
    }
    const publishers = (publishable && current && current.publishers) || [];
    const ownershipOption = getOwnershipOptionByWorkType(
      fields.type,
      fields.subtype,
      ownershipTypes
    );

    let percentTitle = 'copyright';
    if (soundRecordingType === 'revenue') {
      percentTitle = 'revenue split';
    }

    if (current) {
      return (
        <div className="member-ownership">
          <Row className="pt-7px">
            <Col md={4}>
              <span className="text-grey">
                What does this collaborator own?
              </span>
            </Col>
            <Col md={5}>
              <FormGroup>
                {parseInt(fields.subtype, 10) === 1 ? (
                  <Select
                    className="form-control"
                    value={ownershipType}
                    onChange={(e) => this.handleOwnershipType(e.target.value)}
                  >
                    <option value="0">Select One</option>
                    <option value={ownershipOption.id}>
                      {ownershipOption.name}
                    </option>
                    <option value="1">No Ownership</option>
                  </Select>
                ) : (
                  <Select
                    className="form-control"
                    value={ownershipType}
                    onChange={(e) => this.handleOwnershipType(e.target.value)}
                  >
                    <option value="0">Select One</option>
                    <option value="1">No Ownership</option>
                    <option value={ownershipOption.id}>
                      {ownershipOption.name}
                    </option>
                  </Select>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row className="pt-7px">
            <Col md={4}>
              <span className="text-grey">
                What percentage of the {percentTitle} will they own?
              </span>
              <br />
              <br />
              {publishable && parseInt(fields.subtype, 10) !== 1 && (
                <p>
                  <a onClick={this.addPublisher}>+ Add a publisher/society</a>
                  <br />
                  <br />
                </p>
              )}
            </Col>
            <Col md={5}>
              <FormGroup>
                <FormControl
                  ref="ownership"
                  type="text"
                  placeholder="%"
                  value={percentage}
                  onChange={(e) => this.handleOwnership(e)}
                />
              </FormGroup>
            </Col>
            <Col md={1} className="pt-7px">
              %
            </Col>
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-split">
                  Plan on creating more content with this collaborator? If their
                  ownership split will always be the same percentage, check this
                  box to assign this percentage as their default split so that
                  you do not have to re-enter this information next time.
                </Tooltip>
              }
              placement="bottom"
            >
              <Col md={2}>
                <Checkbox
                  checked={current.default}
                  onChange={(e) => this.handleMemberDefault(e)}
                >
                  Default
                </Checkbox>
              </Col>
            </OverlayTrigger>
          </Row>
          {publishers.map((publisher, i) => (
            <Row key={i}>
              <Col md={4}>
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Publisher Name"
                    value={publisher.publisherName}
                    onChange={(e) =>
                      this.handlePublisher(e, 'publisherName', i)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Society(ASCAP, BMI, etc)"
                    value={publisher.society}
                    onChange={(e) => this.handlePublisher(e, 'society', i)}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Publisher Share %"
                    value={publisher.publisher_share}
                    onChange={(e) =>
                      this.handlePublisher(e, 'publisher_share', i)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={1}>
                <a onClick={() => this.removePublisher(i)}>remove</a>
              </Col>
            </Row>
          ))}
        </div>
      );
    }
  }

  render() {
    const { team, status } = this.props;
    const { members } = this.state;

    return team ? (
      <div className="team-module">
        <Row>
          <Col sm={4}>
            <div className="team">
              <div className="top">
                <div className="team-photo">
                  <PhotoContainer
                    className="photo-container"
                    image={team.avatar}
                    defaultImg="team"
                  />
                </div>
                <div className="team-title">{team.name}</div>
              </div>
              <div className="team-members">
                {this.renderMembers()}
                {this.renderShowToggle()}
              </div>
            </div>
          </Col>
          <Col sm={8}>
            {members && members.length ? (
              <div className="member-details">
                {this.renderCurrentMember()}
                {this.renderOwnership()}
                {this.renderTotal()}
              </div>
            ) : (
              status === actionTypes.MEMBERS_GET_SUCCESS && (
                <div className="no-member-details">
                  <p className="main">
                    Oops, go back to select a team with more than 1
                    collaborator!
                  </p>
                  <p>
                    Or, you can edit your team{' '}
                    <Link to={`/teams/${team.id}/detail`}>here</Link>!
                  </p>
                </div>
              )
            )}
          </Col>
        </Row>
      </div>
    ) : null;
  }
}

TeamMembersEdit.defaultProps = {
  soundRecordingType: 'ownership',
  setCurrentMember: () => {},
};

const mapStateToProps = (state) => ({
  roles: state.global.roles,
  team: state.teams.selectedTeam,
  status: state.users.status,
  members: state.users.members,
  fields: state.create.fields,
  workTypes: state.global.workTypes,
  ownershipTypes: state.global.ownershipTypes,
});

const mapDispatchToProps = (dispatch) => ({
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamMembersEdit);



// WEBPACK FOOTER //
// src/components/Agreements/TeamMembersEdit.jsx